import {StyleSheet} from 'react-native';
import {Colors} from '../../constants/Colors';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'white',
    paddingHorizontal: 18,
  },
  flatList: {
    marginBottom: 60,
  },
  inputContainer: {
    marginTop: 30,
  },
  categories: {
    marginTop: 30,
    fontSize: 16,
    fontFamily: 'TCCC-UnityText Bold',
    lineHeight: 19,
    color: 'black',
  },
  containerFilter: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 30,
  },
  buttonFilter: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 8,
  },
  filter: {
    fontSize: 12,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 14,
    marginRight: 10,
  },
  iconContainer: {
    position: 'relative',
    width: 30,
    height: 24,
  },
  filterIcon: {
    width: 20,
    height: 20,
    resizeMode: 'contain',
  },
  badge: {
    position: 'absolute',
    top: -6,
    right: -8,
    backgroundColor: Colors.RedPallete.red || 'darkred',
    borderRadius: 10,
    minWidth: 16,
    height: 16,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 4,
  },
  badgeText: {
    color: 'white',
    fontSize: 10,
    fontFamily: 'TCCC-UnityHeadline Regular',
    textAlign: 'center',
    lineHeight: 14,
  },
  products: {
    fontSize: 16,
    fontFamily: 'TCCC-UnityText Bold',
    lineHeight: 19,
    color: 'black',
  },
  textBuy: {
    fontSize: 12,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 18,
    maxWidth: 180,
    marginTop: 5,
    marginBottom: 20,
    color: Colors.GrayPallete.lightgrayThree,
  },
  space: {
    marginBottom: 100,
  },
  columnFlat: {
    justifyContent: 'space-between',
  },
  notFoundProduct: {
    fontSize: 14,
    fontWeight: '500',
    color: 'darkblue',
  },
  container2: {
    backgroundColor: 'white',
    paddingHorizontal: 20,
  },
  container3: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'white',
  },
  simbol: {
    alignSelf: 'center',
    marginTop: '-22%',
  },
  modalContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
},
modalContent: {
    width: 300,
    padding: 20,
    backgroundColor: 'white',
    borderRadius: 10,
    alignItems: 'center',
},
modalTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 10,
    color: '#333',
},

title: {
  fontSize: 16,
  lineHeight: 19,
  color: 'black',
  fontFamily: 'TCCC-UnityText Bold',
  marginBottom: 30,
},
image: {
  alignSelf: 'center',
},
imageSize: {
  textAlign: 'center',
  alignSelf: 'center',
  maxWidth: 250,
  color: Colors.GrayPallete.lightgrayThree,
  fontFamily: 'TCCC-UnityHeadline Regular',
  marginTop: 20,
},
containerButton: {
  marginTop: 30,
  width: '100%',
},
containerInput: {
  paddingHorizontal: 40,
  marginTop: 30,
},
modalMessage: {
    fontSize: 16,
    marginBottom: 20,
    textAlign: 'center',
    color: '#333',
},
});
